<template>
  <div>
    <v-text-field
      v-model="searchInput"
      solo
      :height="large ? '96px' : '48px'"
      background-color="white"
      prepend-inner-icon="search"
      :label="label"
      :class="[
        menuOpen ? 'fma-lookahead--menu-open' : 'fma-lookahead--menu-closed',
        large ? 'fma-lookahead--large' : ''
      ]"
      @keyup.enter="onSearchSubmit(searchInput)"
      @mousedown="menuOpen = !!searchInput"
      @input="onInput"
      @blur="menuOpen = false"
    >
      <template slot="append">
        <v-btn
          v-if="searchInput"
          icon
          color="primary"
          class="ma-0 fma-round-button"
          :style="large ? 'height: 72px; width: 72px;' : ''"
          @mousedown.stop=""
          @mouseup.stop=""
          @click.stop="() => onSearchSubmit(searchInput)"
        >
          <v-icon :style="large ? 'font-size: 48px;' : ''">
            arrow_forward
          </v-icon>
        </v-btn>
      </template>
    </v-text-field>
    <v-menu
      v-model="menuOpen"
      attach=".theme--light.v-text-field--solo > .v-input__control > .v-input__slot"
      :nudge-bottom="large ? 96 : 48"
      min-width="100%"
      max-width="100%"
      max-height="50vh"
      :close-on-click="false"
    >
      <v-list class="pa-0" :two-line="large">
        <v-list-tile v-if="!results.length">
          <v-list-tile-content class="red--text text--darken-3">
            No results found. Please try a different search term.
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile
          v-for="(item, index) in results"
          :key="index"
          ripple
          @click="
            () => {
              itemSelected(item);
            }
          "
        >
          <div>
            <span>{{ item.title }}</span>
            <span class="pl-4 grey--text"
              >{{ item.count }}
              {{ item.count === 1 ? "result" : "results" }}</span
            >
          </div>
        </v-list-tile>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
export default {
  props: {
    // TODO:
    // eslint-disable-next-line vue/require-default-prop
    items: Array,
    large: Boolean,
    label: {
      type: String,
      default: "Search"
    },
    // TODO:
    // eslint-disable-next-line vue/require-default-prop
    onSearchSubmit: Function
  },
  data() {
    return {
      searchInput: "",
      menuOpen: false,
      results: this.items
    };
  },
  methods: {
    itemSelected(item) {
      this.searchInput = item.title;
    },
    onInput() {
      if (!this.menuOpen && this.searchInput) {
        this.menuOpen = true;
      }
      const startWithSearchTerm = this.items
        .filter(
          item =>
            item.title.toLowerCase().indexOf(this.searchInput.toLowerCase()) ===
            0
        )
        .sort((firstEl, secondEl) => firstEl.title > secondEl.title);
      const containSearchTerm = this.items
        .filter(
          item =>
            item.title.toLowerCase().indexOf(this.searchInput.toLowerCase()) > 0
        )
        .sort((firstEl, secondEl) => firstEl.title > secondEl.title);
      this.results = startWithSearchTerm.concat(containSearchTerm);
    }
  }
};
</script>

<style lang="less">
@import "../assets/global.less";

.fma-lookahead--menu-closed.theme--light.v-text-field--solo
  > .v-input__control
  > .v-input__slot {
  border-radius: 24px;
}

.fma-lookahead--menu-open.theme--light.v-text-field--solo
  > .v-input__control
  > .v-input__slot {
  border-radius: 24px 24px 0 0;
}

.fma-lookahead--large.fma-lookahead--menu-closed.theme--light.v-text-field--solo
  > .v-input__control
  > .v-input__slot {
  border-radius: 48px;
}

.fma-lookahead--large.fma-lookahead--menu-open.theme--light.v-text-field--solo
  > .v-input__control
  > .v-input__slot {
  border-radius: 48px 48px 0 0;
}
</style>
